import { Box, Dialog, makeStyles } from '@material-ui/core';
import React from 'react';
import { RouteLeavingGuard } from './routeLeavingGuard';
import {useHistory} from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  dialogmainwrapper: {
    padding: +theme.spacing,
  },
}));

export const PopupModal = ({ children, open, isDirtyForm, setModal, maxWidth }) => {
  const styles = useStyles();
  const history = useHistory()
  if (!open) return null;
  return (
    <>
      <RouteLeavingGuard
        when={isDirtyForm}
        // Navigate function
        navigate={(path) => {
          history.push(path);
          setModal(false);
        }}
        // Use as "message" prop of Prompt of React-Router
        shouldBlockNavigation={(location) => {
          return true;
        }}
      />
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth={maxWidth || 'md'}
        aria-labelledby="confirmation-dialog-title"
        PaperProps={{
          style: { borderRadius: 20 },
        }}
        open={open}
      >
        <Box className={styles.dialogmainwrapper}>
          {children}
        </Box>
      </Dialog>
    </>
  );
};
